import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Light client-side check purely for UX; the server does the real validation.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | submitting | success
  const [hint, setHint] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHint("");

    const value = email.trim();
    if (!EMAIL_RE.test(value)) {
      setHint("Please enter a valid email.");
      return;
    }

    setStatus("submitting");
    try {
      const res = await fetch(`${API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value }),
      });

      if (res.ok) {
        setStatus("success");
        return;
      }
      if (res.status === 422 || res.status === 400) {
        setStatus("idle");
        setHint("Please enter a valid email.");
        return;
      }
      if (res.status === 429) {
        setStatus("idle");
        setHint("Too many tries \u2014 please wait a moment.");
        return;
      }
      setStatus("idle");
      setHint("Something went wrong \u2014 please try again.");
    } catch (err) {
      setStatus("idle");
      setHint("Something went wrong \u2014 please try again.");
    }
  };

  if (status === "success") {
    return (
      <p className="subscribe-success" aria-live="polite">
        {"Thank you! \uD83D\uDC3E"}
      </p>
    );
  }

  return (
    <form className="subscribe-form" onSubmit={handleSubmit} noValidate>
      <label htmlFor="email" className="sr-only">
        Enter your email for pawsome updates
      </label>
      <input
        id="email"
        className="subscribe-form__input"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email for pawsome updates"
        aria-label="Enter your email for pawsome updates"
        autoComplete="email"
        inputMode="email"
        required
      />
      <button
        className="subscribe-form__button"
        type="submit"
        disabled={status === "submitting"}
      >
        {status === "submitting" ? "\u2026" : "Sign up"}
      </button>

      <div className="subscribe-hint" aria-live="polite">
        {hint}
      </div>
    </form>
  );
}
